import React, { useRef } from 'react';
import * as Highcharts from 'highcharts';
import { HighchartsReact } from 'highcharts-react-official';
import { CHART_COLORS } from '@/constants/common';
import { IEmailProcessingStats } from '../types';


interface EmailGraphProps {
  width: number;
  emailProcessingStats: IEmailProcessingStats;
}

const getOptions = ({ width, emailProcessingStats }: EmailGraphProps): Highcharts.Options => { 


  return({
    chart: {
        type: 'pie',
        margin: 0,
        height: width,
        marginRight: width + 20
    },
    title: {
        text: ''
    },

    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: false
            },
            showInLegend: true,
            innerSize: '65%',
            size: '80%'
        }
    },
    legend: {
        align: 'right',
        verticalAlign: 'middle',
        width: width - 10,
        alignColumns: false,
        useHTML: true,
        itemMarginTop: 10,
        itemStyle: {
          lineHeight: 1
        },
        labelFormatter: function () {
            const series = this;
            const isTotal = series.name === 'Total emails'
            return `
              <div style="display: flex; gap: 4px; align-items: center;">
                <span style="display: inline-block; width: 152px; ${isTotal ? 'font-weight: 700' : ''}">
                  ${this.name}
                </span>
                <b>${(this as unknown as any).y}</b>
              </div>
            `;
        }
    },
    series: [
      {
        type: 'pie',
        name: 'count',
        data: [
          { y: emailProcessingStats?.unprocessedEmails ?? 0, name: 'Unprocessed emails', color: CHART_COLORS[0]}, 
          { y: emailProcessingStats?.processedEmails ?? 0, name: 'Processed emails', color: CHART_COLORS[1]}, 
          { y: emailProcessingStats?.reviewEmails ?? 0, name: 'Emails for reviews', color: CHART_COLORS[2]}, 
          { y: emailProcessingStats?.failedEmails ?? 0, name: 'Failed emails', color: CHART_COLORS[3]}, 
        ],
        
    }]
})};



const EmailGraph = (props: EmailGraphProps) => {
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={getOptions(props)}
      ref={chartComponentRef}
    />
  );
};

export default EmailGraph;
